/* eslint-disable default-param-last */
/* eslint-disable no-console */
import { GlobalState } from '@leverege/ui-redux';
export default class AbstractGroupDelegate {
  getGroup() {
    return this;
  }

  /**
   * Returns the interface url for this group action object
   */
  getInterfaceUrl() {
    console.warn('unimplemented: GroupDelegate.getInterfaceUrl');
  }

  /**
   * Returns the url for this group action object
   */
  getUrl() {
    console.warn('unimplemented: GroupDelegate.getUrl');
  }

  /**
   * Returns the parent's action object. This function is optional and
   * only needs to be implemented if the given group can have a parent item.
   * Not all items are hierarchical in this way
   */
  parent() {
    console.warn('unimplemented: GroupDelegate.parent');
  }

  /**
   * Creates a item action for the id in the group.
   * @deprecated use item( id )
   */
  itemActions(id) {
    console.warn('unimplemented: GroupDelegate.itemActions');
  }

  /**
   * OPTIONAL
   * Creates an item action for the id in the group. This function is
   * optional but highly recommended since it allows for managing items
   * at an individual level rather than group level where logical. This should only
   * be implemented if the data this class is tied to can support it.
   */
  item(id) {
    console.warn('unimplemented: GroupDelegate.item');
  }

  /**
   * TODO: Should this be in the abstract class?
   * @param {string} id 
   */
  itemRef(id) {
    console.warn('unimplemented: GroupDelegate.itemRef');
  }

  /**
   * Returns a redux action or thunk function that will request to create an item as a child of the current group
   * @param {object} obj item to be created
   * @param {object} options api options
   * @returns {Object|function} redux action or thunk function
   */
  create(obj, options) {
    console.warn('unimplemented: GroupDelegate.create');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will ask the api if you can create an item at the current path.
   * @param {object} query  query object to send to the api
   * @param {object} body the data of the object to create
   * @returns {Object|function} redux action or thunk function
   */
  requestCanCreate(query, body) {
    console.warn('unimplemented: GruopActions.requestCanCreate');
  }

  /**
   * OPTIONAL
   * Like create, but it will use the id to add an already existing device. By default,
   * force is set true to reparent the object
   * @param {string} id the id to add to the group
   * @param {Object} options an optional option set
   * @returns {Object|function} redux action or thunk function
   */
  add(id, options) {
    console.warn('unimplemented: GroupDelegate.add');
  }

  /**
   * Returns a redux action or thunk function that will ask the api to list the items in a group
   * @param {Object} options the options to send to the api with the list request
   * @returns {Object|function} redux action or thunk function
   */
  list(options) {
    console.warn('unimplemented');
  }

  /**
   * Returns true if this delegate is capable of converting `cnd` to a filter
   * object suitable for use with `search`
   * 
   * @param {Object} cnd The condition model to convert to a filter object
   */
  canConvertCondition(cnd) {
    console.warn('unimplemented: GroupDelegate.canConvertCondition');
    return false;
  }

  /**
   * Returns true if this delegate is capable of converting `cmp` to a filter
   * object suitable for use with `search`
   * 
   * @param {Object} cmp The comparator model to convert to a filter object
   */
  canConvertComparator(cmp) {
    console.warn('unimplemented: GroupDelegate.canConvertComparator');
    return false;
  }

  /**
   * Converts a condition model to a filter object suitable for use with the `search` function
   * 
   * @param {Object} cnd The condition model to convert to a filter object
   * @param {Object} cxt The context passed to the action from the calling client
   */
  convertToFilter(cnd, cxt) {
    console.warn('unimplemented: GroupDelegate.convertToFilter');
  }

  /**
   * Like list, but list is traditionally a get, and search is traditionally a post if that differentiation
   * is possible in the api
   * @param {Object} search the search object
   * @param {Object} options any additional options to send to the api
   * @returns {Object|function} redux action or thunk function
   */
  search(search, options) {
    console.warn('unimplemented: GroupDelegate.search');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will ask the api if you can read the item at the current path
   * @param {object} query  query object to send to the api
   * @returns {Object|function} redux action or thunk function
   */
  requestCanList(query) {
    console.warn('unimplemented: GroupDelegate.requestCanList');
  }

  /**
   * OPTIONAL (not all api's will support update capabilities)
   * Returns a redux action or thunk function that will call the api to update a child of the current path
   * @param {string} id id of the item to be updated
   * @param {object} data values of the item to be changed
   * @param {object} options api options
   * @returns {Object|function} redux action or thunk function
   */
  update(id, data, options) {
    console.warn('unimplemented: GroupDelegate.update');
  }

  /**
   * OPTIONAL
   * Returns a redux action that will ask the api if you can update the item at the current path
   * @param {string} id id of the item to ask api about updating
   * @param {object} query  query object to send to the api
   * @param {object} body the data of the update
   * @returns {Object|function} redux action or thunk function
   */
  requestCanUpdate(id, query, body) {
    console.warn('unimplemented: GroupDelegate.requestCanUpdate');
  }

  /**
   * OPTIONAL (not all api's will support delete capabilities)
   * Returns a redux action or thunk function that will call the api to delete a child of the current path
   * @param {string} id id of the item to be deleted
   * @param {object} options api options
   * @returns {Object|function} redux action or thunk function
   */
  delete(id, body, options, reducerOptions) {
    console.warn('unimplemented: GroupDelegate.delete');
  }

  /**
   * OPTIONAL
   * Returns a redux action or thunk function that will ask the api if you can delete the item at the current path
   * @param {string} id id of the item to be deleted
   * @param {object} query  query object to send to the api
   * @param {object} body body of the request to test
   * @returns {Object|function} redux action or thunk function
   */
  requestCanDelete(id, query, body) {
    console.warn('unimplemented: GroupDelegate.requestCanDelete');
  }

  /**
   * OPTIONAL (not all api's will support history for groups or items)
   * Returns a redux action or thunk function that makes an api call to get the history of an object at the path
   * @param {object} query the query to send to the api
   * @param {object} options api options
   * @returns {Object|function} redux action or thunk function
   * @deprecated
   */
  history(query, options) {
    console.warn('unimplemented: GroupDelegate.history');
  }

  /**
   * OPTIONAL (not all api's will support history for groups or items)
   * Returns a redux action that will ask the api if you can get history at the current path
   * @param {object} query  query object to send to the api
   * @returns {Object|function} redux action or thunk function
   * @deprecated
   */
  requestCanHistory(query) {
    console.warn('unimplemented: GroupDelegate.requestCanHistory');
  }

  /**
   * Get whether or not you can drill in to a particular item in the group. Not all api's will
   * have item screen capabilities, and it may not be desired.
   * @returns {boolean} whether or not molten can drill in to the item
   */
  isGotoAllowed() {
    console.warn('unimplemented: GroupDelegate.isGotoAllowed');
  }

  /**
   * OPTIONAL
   * Returns a redux action to go to the child's url. If id is undefined,
   * this will push a link to the group
   * @param id {string} the id of the item to go to
   * @returns {Object} the redux action
   */
  goTo(id) {
    if (this.isGotoAllowed()) {
      console.warn('unimplemented: GroupDelegate.goTo');
    }
    return {
      type: 'noop'
    };
  }

  /**
   * Get the status of any current api calls to this group (typically for list/search calls)
   * @param {Object} state the redux state (or other local state) to get api status from
   * @returns {*} returns the status of the groups api calls
   */
  getStatus(state = GlobalState.get()) {
    console.warn('unimplemented: GroupDelegate.getStatus');
  }

  /**
   * Get the local list as retrieved from the api
   * @param {Object} state the redux state (or other local state) to get the list from
   * @param {Object} options any options to specify how to get the list
   * @returns {*} returns the list received from the api
   */
  getList(state = GlobalState.get(), options) {
    console.warn('unimplemented: GroupDelegate.getList');
  }

  /**
   * OPTIONAL
   * Get the list's history as retrieved from the api
   * @param {Object} state the redux state (or other local state) to get history from
   * @param {Object} options any options to specify how to get the history
   * @returns {*} returns the history received from the api
   * @deprecated
   */
  getHistory(state = GlobalState.get(), queryName) {
    console.warn('unimplemented: GroupDelegate.getHistory');
  }

  /**
   * Get whether or not the delegate are waiting on any api requests
   * @param {Object} state the redux state (or other local state) to get api status from
   * @returns {*} returns whether or not this is loading
   */
  isLoading(state = GlobalState.get()) {
    console.warn('unimplemented: GroupDelegate.isLoading');
  }

  /**
   * Basically the opposite of isLoading, check whether or not all
   * api requests are complete (regardless of failure)
   * @param {Object} state the redux state (or other local state) to get api status from
   * @returns {*} returns whether or not this is loading
   */
  isDone(state = GlobalState.get()) {
    console.warn('unimplemented: GroupDelegate.isDone');
  }
  // accessors

  /**
   * OPTIONAL
   * Accesses whether or not a user can create an item at this path in the api from state
   * @param {object} state redux state
   */
  canCreate(query, body, state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: GroupDelegate.canCreate');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can list the items at this path in the api from state
   * @param {object} state redux state
   */
  canList(state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: GroupDelegate.canList');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can update an item at this path in the api from state
   * @param {object} state redux state
   * @param {string} id the id of the device to test against
   */
  canUpdate(id, state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: GroupDelegate.canUpdate');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can delete an item at this path in the api from state
   * @param {string} id the id of the device to test against
   * @param {object} state redux state
   */
  canDelete(id, query, body, state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: GroupDelegate.canDelete');
  }

  /**
   * OPTIONAL
   * Accesses whether or not a user can get history at this path in the api from state
   * @param {object} state redux state
   * @param {string} id the id of the device to test against
   * @deprecated
   */
  canHistory(state = GlobalState.get(), requestIfUnavailable = true) {
    console.warn('unimplemented: GroupDelegate.canHistory');
  }
}